import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';

@Component({
  selector: 'form-input',
  styleUrls: ['form-input.component.scss'],
  template: `
    <div 
      class="dynamic-field form-input"
      [ngClass]="{'required': required}" 
      [formGroup]="group">
      <label>{{ config.label }}</label>
      <input
        type="text"
        [attr.placeholder]="config.placeholder"
        [formControlName]="config.name">
    </div>
  `
})
export class FormInputComponent implements OnInit, Field {
  config: FieldConfig;
  group: FormGroup;
  options: any;

  protected required = false;

  ngOnInit() {

    if (this.config.validation !== undefined
        && this.config.validation.filter(v => v.toString() === 'Validators.required').length > 0) {
      this.config.placeholder += ' (Obrigatório)';
      this.required = true;
    } else {
      this.required = false;
    }

  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/dynamic-form/components/form-input/form-input.component.ts